import type { FunctionComponent, PropsWithChildren } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import styles from "./PrivateOfferButton.module.css"

type PrivateOfferButtonProps = PropsWithChildren<{
  href: string
}>

export const PrivateOfferButton: FunctionComponent<PrivateOfferButtonProps> = ({ children, href }) => {
  return (
    <Button className={styles.main} as="a" href={href} variant="secondary">
      {children}
    </Button>
  )
}
